import { type ReactNode } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import type { PaginationConfig } from "../types";

export function useTablePagination(
  dataLength: number,
  pagination?: PaginationConfig,
) {
  const isFetchingNextPage =
    pagination?.type === "infinite"
      ? (pagination.isFetchingNextPage ?? false)
      : false;

  function wrap(children: ReactNode): ReactNode {
    if (!pagination) return children;

    if (pagination.type === "infinite") {
      return (
        <InfiniteScroll
          dataLength={dataLength}
          next={pagination.next}
          hasMore={pagination.hasMore}
          loader={null}
          scrollableTarget={pagination.scrollableTarget}
          style={{ overflow: "visible" }}
        >
          {children}
        </InfiniteScroll>
      );
    }

    return children;
  }

  return { wrap, isFetchingNextPage };
}
